module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-scary.070425d7.png";